import { action } from 'mobx';

import type { AgentBranch, AgentBranchOptions } from '../../model';

export const getAgentBranchOptions = action(
  (agentBranchData: AgentBranch[] | undefined): AgentBranchOptions => {
    const resultOptions: AgentBranchOptions = {
      branchOptions: [],
      blockedBranchOptions: {},
    };

    if (!agentBranchData) return resultOptions;

    return agentBranchData.reduce(
      (result, { name, code, isOnlineRegistrationBlocked }) => {
        result.branchOptions.push({ label: name, value: code });

        if (isOnlineRegistrationBlocked) {
          result.blockedBranchOptions[code] = true;
        }

        return result;
      },
      resultOptions
    );
  }
);
